'use client';

import { useEffect } from 'react';

const CHUNK_RELOAD_STORAGE_KEY = 'admin-chunk-reload-attempts';
const MAX_CHUNK_RELOAD_ATTEMPTS = 2;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.error('Global error caught:', error);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const message = `${error?.name ?? ''} ${error?.message ?? ''}`;
    const isChunkLoadError =
      message.includes('ChunkLoadError') || message.includes('Loading chunk');

    if (!isChunkLoadError) {
      sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
      return;
    }

    const attempts = Number(sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) ?? '0');

    if (attempts < MAX_CHUNK_RELOAD_ATTEMPTS) {
      sessionStorage.setItem(
        CHUNK_RELOAD_STORAGE_KEY,
        String(attempts + 1),
      );

      console.warn(
        '[Admin] Chunk load error detected. Forcing a hard reload to fetch the latest assets.',
      );

      const timeout = window.setTimeout(() => {
        window.location.reload();
      }, 500);

      return () => {
        clearTimeout(timeout);
      };
    }

    console.error(
      '[Admin] Chunk load error persists after hard reload attempts. Showing manual retry button.',
    );
  }, [error]);
  
  return (
    <html>
      <body>
        <div style={{ 
          padding: '40px', 
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          maxWidth: '600px',
          margin: '100px auto'
        }}>
          <h2 style={{ color: '#e53e3e', marginBottom: '20px' }}>حدث خطأ ما!</h2>
          <p style={{ color: '#4a5568', marginBottom: '30px' }}>
            نعتذر عن الإزعاج. يرجى المحاولة مرة أخرى.
          </p>
          <button 
            onClick={() => reset()}
            style={{
              backgroundColor: '#3182ce',
              color: 'white',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            إعادة المحاولة
          </button>
        </div>
      </body>
    </html>
  );
}
